import config from 'config'
import { openLinkBlank } from 'utils/appSchemeUtil'

export const facebookShare = ({ href, success, fail }) => {
  window.FB.init({
    appId: config.FB_APPID,
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v8.0',
  })
  window.FB.ui(
    {
      display: 'popup',
      method: 'share',
      href,
    },
    (response) => {
      if (response && !response.error_message) {
        // TODO: track facebook share success e_a:response
        success && success(response)
        console.log('facebook share completed.')
      } else {
        // TODO: track facebook share failed e_a:response
        fail && fail(response)
        console.log('Error while posting facebook share.')
      }
    }
  )
}

export const whatsAppShare = (href) => {
  openLinkBlank(`https://api.whatsapp.com/send?text=${href}`)
}
